import { render, staticRenderFns } from "./WorkToggleableContent.vue?vue&type=template&id=33c2cd10&scoped=true"
import script from "./WorkToggleableContent.vue?vue&type=script&lang=js"
export * from "./WorkToggleableContent.vue?vue&type=script&lang=js"
import style0 from "./WorkToggleableContent.vue?vue&type=style&index=0&id=33c2cd10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2cd10",
  null
  
)

export default component.exports